import { useCallback, useRef } from 'react';

interface ResizeHandleProps {
  onResize: (deltaX: number) => void;
}

/** A thin draggable divider between two panels. Reports raw pointer delta-x per move;
 * the caller owns clamping so it can apply its own min/max width rules. */
export default function ResizeHandle({ onResize }: ResizeHandleProps) {
  const lastX = useRef(0);

  const handlePointerDown = useCallback(
    (e: React.PointerEvent<HTMLDivElement>) => {
      e.preventDefault();
      lastX.current = e.clientX;
      const target = e.currentTarget;
      target.setPointerCapture(e.pointerId);

      function handlePointerMove(ev: PointerEvent) {
        const delta = ev.clientX - lastX.current;
        lastX.current = ev.clientX;
        onResize(delta);
      }
      function handlePointerUp() {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerUp);
      }
      window.addEventListener('pointermove', handlePointerMove);
      window.addEventListener('pointerup', handlePointerUp);
    },
    [onResize],
  );

  return (
    <div
      onPointerDown={handlePointerDown}
      className="group relative w-1 shrink-0 cursor-col-resize select-none bg-black/5 hover:bg-sky-300 dark:bg-white/5 dark:hover:bg-sky-500"
    >
      <div className="absolute inset-y-0 -left-1 -right-1" />
    </div>
  );
}
